import React from 'react';
import { QuoteCalculatorAPI } from '../../action/quoteCalculator/quoteCalculator'
import {NumericFormat} from "react-number-format";
import { GTMUserIdAndLoginState } from '../../utils/GtmDatalayer';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import withRouter from '../../withRouter';
class RetailerPlanSection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            amount: '',
            storeError: '',
            searchValue: this.props.hasPartnerDetails?.store_name || '',
            displayData: this.props.amount,
            hasDisplay: true,
            isSelected: false,
            hasPartnerDetails: {},
            searchResult: [],
            errors: {
                AmountError: ''
            },
            isAmountChanged: false,
        }
        this.onHandleChange = this.onHandleChange.bind(this);
        this.filterResult = this.filterResult.bind(this);
        this._onValueChange = this._onValueChange.bind(this);
    }

     componentDidMount() {
        this.setState({
            searchValue: this.props.hasPartnerDetails?.store_name || '',
            displayData: this.props.amount,
        });
        if (!this.props.isApplicationNormalFlow && this.props.hasPartnerDetails?.id && this.props.hasPartnerDetails?.store_name) {
            this.setState({
                hasPartnerDetails: {
                    'id': this.props.hasPartnerDetails?.id,
                    'store_name': this.props.hasPartnerDetails?.store_name,
                }
            })
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.hasPartnerDetails?.store_name !== this.props.hasPartnerDetails?.store_name) {
            this.setState({
                searchValue: this.props.hasPartnerDetails?.store_name || '',
            });
        }
        if (prevProps.amount !== this.props.amount) {
            this.setState({
                displayData: this.props.amount || '',
            });
        }
        if ((prevProps.hasPartnerDetails?.store_name !== this.props.hasPartnerDetails?.store_name) && (prevProps.hasPartnerDetails?.id !== this.props.hasPartnerDetails?.id)) {
            this.setState({
                hasPartnerDetails: {
                    'id': this.props.hasPartnerDetails?.id,
                    'store_name': this.props.hasPartnerDetails?.store_name,
                }
            })
        }
    }

    // Verification done
    async onHandleChange(e) {
        let value = e.target.value;
        this.setState({ hasPartnerDetails: {} });
        this.setState({ searchValue: value });
        this.filterResult();
        if (value.trim() === '') {
            this.setState({
                storeError: "Retailer is required",
                isSelected: false,
                hasPartnerDetails:{}
            })
        }
        else if (this.state.searchResult.length == 0) {
            this.setState({ storeError: "Retailer is not in the list", hasDisplay: false, hasPartnerDetails:{} })
        }
        else {
            this.setState({
                storeError: "", hasDisplay: true
            })
        }
        this.setState({ searchValue: e.target.value })
        this.filterResult();
        this.updateFromValidation();
    }

    // Verification done
    addClassnames = (displayState) => {
        if(displayState){
            return "search-body show-option"
        }
        else {
            return "search-body hide-option"
        }
    }

    // verification done
    /* set the retailerIds in the list of states to display in the UI while the user can 
    searching the retailer Id during typing the retailer id in the store input field */    
    suggestionSelected = (values) => {
        this.setState({
            searchValue: values.store_name,
            hasPartnerDetails: values,
            hasDisplay: false,
            isSelected: true,
            storeError: ""
        },
        () => {
            this.updateFromValidation();
        })
    };

    // Verification done
    _isAllowedCheck = (values) =>{
        if(values != ''){
            const { value } = values;
            return Boolean(value <= 1000000);
        }
    }

    // Verification done
    async _onValueChange(event) {
        let { formattedValue, value } = event;
        if (Number(value) <= 1000000) {

            if (Number.parseFloat(value, 10) != 0) {
                this.setState({ amount: value, ErrorMessage: "", displayData: formattedValue });
            }
            else {
                this.setState({ displayData: "" })
            }
        }
        else {
            console.log("false")
        }       
        if (value.length == 0 && value == "") {
            this.setState({ errors: { AmountError: "Loan Amount is required" } });
        }
        else {
            this.setState({ errors: { AmountError: "" } })
        }
    }

    // Verification done
    onKeyPressBlock = (event) => {
        if(event.key === '-'){
            event.preventDefault();
            return false;
        }
    }

    // Verification done
    onBlurChange = (event) => {
        let name = event.target.name;
        let value = event.target.value
        if (name === 'purchase-amount') {
            if (value.length !== 0) {
                if(value.indexOf(".") >= 0){
                    let decimal_pos = value.indexOf(".");
                    let left_side = value.substring(0, decimal_pos);
                    let right_side = value.substring(decimal_pos);
                    let replaceLeftSide=left_side.replace(/\D/g, "").replaceAll(',','');
                    right_side = right_side.substring(0, 3);
                    if(right_side.length===2){
                    right_side=right_side+'0';
                    }
                if(right_side.length===1){
                    right_side='.00';
                }
                value=replaceLeftSide+right_side;
                this.setState({displayData: value})
                
                }else{
                    value = value.replace(/\D/g, "").replaceAll(',','')+'.00';

                    this.setState({ displayData:value })
                
                }
            }
        }
    }


    // Verification done
    filterResult() {
        let filterDetails;
        filterDetails = this.props.storeName.filter(
            (listitem) => {
                return listitem.store_name.toLowerCase().includes(this.state.searchValue?.toLocaleLowerCase());
            }
        );
        this.setState({ searchResult: filterDetails });
    }

    updateFromValidation() {
        let hasDisplayFlag = this.state.hasDisplay
        let retailerSelected;
        if (this.state.hasPartnerDetails && Object.keys(this.state.hasPartnerDetails).length > 0) {
            retailerSelected = this.state.hasPartnerDetails
        } else {
            retailerSelected = this.props.hasPartnerDetails
            hasDisplayFlag = false
        }
        const isFromValidated = Object.values(this.state.hasPartnerDetails).length != 0 && this.state.amount != '';
        const amount = Number.parseFloat(String(this.state.amount).replace(/[^\d.-]/g, ''),10) || '';
        const retailer = retailerSelected;
        const hasDisplay = hasDisplayFlag;
        this.props.onFormCompleted(isFromValidated, amount, retailer, hasDisplay);
    }

    render() {
        return (
            <>
                {!this.props.isSelectPlanNext && (
                    <div className="select-retailer-details-section">
                        <p className='text-left'><span style={{ fontWeight: "700", display: "inline", color: "#212529", fontStyle: "italic" }}>
                            humm</span> is committed to providing you with financial solutions that are tailored to your needs.
                        </p>
                        <p className='text-left'>
                            We do have some basic criteria you'll have to meet before we can consider your application. You must:
                        </p>
                        <ul>
                            <li>Be aged 18+</li>
                            <li>Have been a resident of the UK for at least 6 months</li>
                            <li>Have a UK credit or debit card in your own name</li>
                        </ul>
                    </div>
                )}

                {this.props.isSelectPlanNext && (
                    <div className="select-plan-section">
                        <h3 className="plan-selection-heading text-center">Now choose your repayment plan </h3>
                        <p>Select the loan term that works best for your budget. Compare monthly payments, interest rates, and total costs.</p>
                    </div>
                )}
            <div className="Qc-form-body-section text-left">
                <div className="row">
                    <div className="col-md-4 col-sm-12 col-12 my-0" style={{ position: 'relative' }}>
                        <div className="form-group store-name">
                            <label>
                                {((!this.state.hasDisplay && Object.keys(this.state.hasPartnerDetails).length !== 0) || !this.props.isApplicationNormalFlow) ? 'Retailer' : 'Select Retailer'}
                            </label>
                            <input type="text" className="form-control store-name" name="store"
                                value={this.state.searchValue}
                                disabled={ this.props.isDisabled }
                                placeholder="Start typing"
                                autoComplete="off"
                                onChange={(e) => this.onHandleChange(e)} />
                        </div>
                        <div className="search-result-item">
                            <div className={ this.addClassnames(this.state.hasDisplay) } >
                                <ul className="m-0 p-0">
                                    {this.state.searchValue &&
                                        this.state.searchResult.map(list =>
                                            <li className="search-list" key={list.id}
                                                onKeyDown={(e) => { e.preventDefault(); }}
                                                onClick={(_e) => this.suggestionSelected(list)}>{list.store_name}</li>
                                        )
                                    }
                                </ul>
                            </div>
                            <p className="error-message card-holder-error">{this.state.storeError}</p>
                        </div>
                    </div>
                    <div className="col-md-4 col-sm-12 col-12">
                        <div className="form-group">
                            <span>Loan Amount</span>
                            <NumericFormat 
                                className={"form-control amount-input"}
                                placeholder="Enter amount"                                                
                                name="purchase-amount"
                                disabled={(this.props.isAmountAvailable)}
                                value={this.state.displayData}
                                decimalScale={2}
                                isAllowed={this._isAllowedCheck}
                                thousandSeparator={true}
                                prefix={"£"}
                                autoComplete="off"
                                onValueChange={this._onValueChange}
                                onChange={(e) => {
                                    const newValue = e.target.value;
                                    this.setState({
                                        displayData: newValue,
                                        amount: newValue
                                    }, () => {
                                        this.updateFromValidation();
                                        this.props.isAmountUpdated(true)
                                        this.setState({ isAmountChanged: true });
                                    });
                                }}
                                onKeyPress={this.onKeyPressBlock}
                                onBlur={this.onBlurChange}
                            />
                            {this.state.isAmountChanged && (
                                <p className="error-message card-holder-error">{this.state.errors.AmountError}</p>
                            )}
                            {this.props.NoRetailerMessage && !this.state.errors.AmountError && (
                                <p className="error-message card-holder-error">{this.props.NoRetailerMessage}</p>
                            )}
                        </div>
                    </div>
                    {(this.props.isDisabled && this.props.recalculationRequired && this.props.isSelectPlanNext) && (
                        <div className="col-md-4 col-sm-12 col-12">
                            <div className="retailer-form-section">
                                <button disabled={this.state.amount == ''} type="button" className="qc-confirm-btn btn recalculate-button" onClick={this.props.recalculateOperation}>Calculate Again</button>
                            </div>
                        </div>
                    )}
                </div>
            </div> 
            </>    
        );
    }
}

RetailerPlanSection.propTypes = {
    hasPartnerDetails: PropTypes.shape({
        store_name: PropTypes.string,
        id: PropTypes.string,
    }),
    amount: PropTypes.string,
    NoRetailerMessage: PropTypes.string,
    isSelectPlanNext: PropTypes.bool,
    isApplicationNormalFlow: PropTypes.bool,
    storeName: PropTypes.func,
    onFormCompleted: PropTypes.func,
    isDisabled: PropTypes.bool,
    isAmountAvailable: PropTypes.bool,
    isAmountUpdated: PropTypes.func,
    recalculateOperation: PropTypes.func,
    recalculationRequired: PropTypes.bool
};

export default withRouter(RetailerPlanSection);

